/**
 * Site-wide navigation link lists, read from xconvert-web-ssr (owner 2026-10-11, HANDOFF-L4 H5: one source of truth for
 * page copy = the ssr). `site-nav.generated.json` is the tracked byte copy of ssr `sources/site-nav.json`
 * (`npm run copy:site-nav`; commons/__tests__/site-nav.ssr.drift.spec.ts fails when it differs from the sibling checkout).
 * Rendered by components/footer/footer-v2.component.tsx (columns + legal row), components/header/tools-panel.component.tsx
 * (popular chips) and components/media-tools/media-tools-page.component.tsx (Format Converters). Nothing here is typed
 * copy: edit the ssr file and re-copy.
 */
import nav from './site-nav.generated.json';

export interface NavLink { text: string; href: string }
export interface FooterColumn { title: string; links: NavLink[] }

/** Footer tool columns, in order. */
export const FOOTER_COLUMNS: readonly FooterColumn[] = nav.footer.columns;
/** Footer bottom row (About, Privacy, Terms, Contact, Help Us Grow). */
export const FOOTER_LEGAL_LINKS: readonly NavLink[] = nav.footer.legal;
/** Tools panel "Popular" chips. */
export const HEADER_POPULAR_TOOLS: readonly NavLink[] = nav.header.popular;
/** Per-format converter hubs by media type (VIDEO / IMAGE / AUDIO) for the hub pages' "Format Converters" section. */
export const FORMAT_HUBS_BY_MEDIATYPE: Readonly<Record<string, readonly NavLink[]>> = {
    VIDEO: nav.formatHubs.VIDEO, IMAGE: nav.formatHubs.IMAGE, AUDIO: nav.formatHubs.AUDIO,
};
